import { useEffect } from 'react';
import { navigate, useRoute } from './lib/router';
import { Landing } from './ui/Landing';
import { Room } from './ui/Room';

export function App() {
  const route = useRoute();

  useEffect(() => {
    document.title = route.name === 'room' ? `${route.code} · Battlequip` : 'Battlequip';
  }, [route]);

  if (route.name === 'home') return <Landing />;

  if (route.name === 'not-found') {
    return (
      <main className="fatal">
        <h1>No such room</h1>
        <button type="button" className="button button--primary" onClick={() => navigate('/')}>
          Start a new game
        </button>
      </main>
    );
  }

  return <Room code={route.code} />;
}
